/**
 * Minified by jsDelivr using Terser v5.10.0.
 * Original file: /npm/vue@3.2.31/dist/vue.global.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
